module.exports = __webpack_public_path__ + "line_logo.8c9079aae383895cc563a7790c4fef07.png";